import { Component, OnInit, ViewChild } from '@angular/core';
import { Usuario } from '../models/usuario';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router'

import { ClienteService } from '../services/cliente.service';
import { ListadoClientes } from '../models/viewmodels/listadoClientes';
import { ClienteViewModel } from '../models/viewmodels/clienteViewModel';
import { CustomAlertComponent } from '../shared/custom-alert/custom-alert.component';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  usuario: Usuario = {
    password: null,
    username: null
  };

  alert: any = {
    tipo: "danger",
    titulo: "Verifique",
    mensaje: "El usuario o la contraseña no son válidos.",
    visible: false
  }

  @ViewChild(CustomAlertComponent)
  private alertComponent: CustomAlertComponent;


  constructor(private authService: AuthService, private router: Router, private clienteService: ClienteService) { }

  ngOnInit() {    
  }

  onSubmit() {

    this.authService.login(this.usuario.username, this.usuario.password).subscribe(result => {
      if (result === true) {
        // login successful
        if (this.authService.roles.indexOf("administrador") > -1) {
          this.router.navigate(['dashboard/clientes']);
        } else if (this.authService.roles.indexOf("usuario") > -1) {
            this.router.navigate(['clientes']);                         
        }else if (this.authService.roles.indexOf("intranet") > -1) {
          this.router.navigate(['intranet/kairos']);
        }
      } else {
        // login failed                    
        this.alert.visible = true;
        this.alert.closed = false;
        this.alert.tipo = "danger"
        this.alertComponent.setType(this.alert.tipo); 
      }
    },  error => {
      this.alert.visible = true;
        this.alert.closed = false;
        this.alert.tipo = "danger"
        this.alertComponent.setType(this.alert.tipo);
    });
  }
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/login/login.component.ts